// extracted by mini-css-extract-plugin
export default {"error-modal":"ErrorModal_error-modal__BIPSD","error-modal__actions":"ErrorModal_error-modal__actions__6UzTw","backdrop":"ErrorModal_backdrop__iw-9R"};